import type { Game } from 'shared-types/games';
import { useAppDispatch, useAppSelector } from '../redux-hook';
import { clearGame, setCurrentGame, setPlayers } from './slice';

export const useGameLoadingSelector = () => {
  return useAppSelector((state) => state.game.loading);
};

export const useGameErrorSelector = () => {
  return useAppSelector((state) => state.game.error);
};

export const useCurrentGameSelector = () => {
  return useAppSelector((state) => state.game.currentGame);
};

export const useSetCurrentGame = () => {
  const dispatch = useAppDispatch();

  return {
    setCurrentGame: (currentGame: Game | null) => dispatch(setCurrentGame(currentGame)),
  };
};

export const useSetPlayers = () => {
  const dispatch = useAppDispatch();

  return {
    setPlayers: (players: string[]) => dispatch(setPlayers(players)),
  };
};

export const usePlayersSelector = () => {
  return useAppSelector((state) => state.game.players);
};

export const useClearGame = () => {
  const dispatch = useAppDispatch();

  return {
    clearGame: () => dispatch(clearGame()),
  };
};
